import * as React from "react";
import { gql, ChildProps, graphql, compose, MutationFunc } from "react-apollo";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import { RouteComponentProps } from "react-router";
import { GqlWithdrawalRequest } from "../../Withdrawals/withdrawalRequestsColumns";
import BatchWithdrawalRequestsContainer from "../../Withdrawals/BatchWithdrawalRequestsContainer";
import withDialog, { DialogProp } from "app/utils/withDialog";
import SubmitBatchWithdrawalsButton from "../../Withdrawals/SubmitBatchWithdrawalsButton";

type GqlQueryResult = {
  withdrawal_batches: Array<{
    id: string;
    status: string;
    archive_url: string;
    comment: string;
    withdrawal_requests: Array<GqlWithdrawalRequest>;
  }>;
};

type GqlSubmitMutationResult = {
  submit_withdrawal_batch: {
    id: string;
  };
};
type GqlNamedMutations = {
  submitWithdrawalBatchMutation: MutationFunc<GqlSubmitMutationResult>;
};

type Props = ChildProps<
  BOComponentProps &
    RouteComponentProps<{
      id: string;
    }> &
    DialogProp &
    GqlNamedMutations,
  GqlQueryResult & GqlSubmitMutationResult
>;

class WithdrawalsBatchSummary extends React.Component<Props> {
  componentDidMount() {
    this.props.setHeader({
      title: `Wallet Withdrawal Batch ${this.props.match.params.id}`,
      description: "Wallet Withdrawal Batch Summary",
    });
  }

  onSubmit() {
    this.props.data.refetch();
  }

  render() {
    if (this.props.data.loading) {
      return "";
    }

    const batch = this.props?.data?.withdrawal_batches?.length
      ? this.props.data.withdrawal_batches[0]
      : null;

    return (
      <BOGraphQLLoader data={this.props.data}>
        <section
          id="Settlements_Withdrawal_Batch_Summary"
          className="padded scrollable"
        >
          {batch?.status === "pending" ? (
            <div
              style={{
                marginRight: "10px",
                position: "absolute",
                right: "10px",
                top: "10px",
              }}
            >
              <SubmitBatchWithdrawalsButton
                batchId={batch.id}
                onSubmit={this.onSubmit.bind(this)}
              />
            </div>
          ) : null}
          <label>
            <b>Settlement Archive: </b>
            {!!batch?.archive_url ? (
              <a
                className="blueLink"
                target="_blank"
                rel="noopener noreferrer"
                href={batch?.archive_url}
              >
                Download
              </a>
            ) : (
              <i>No Value.</i>
            )}
          </label>
          <br />
          <label>
            <b>Comment:</b> {batch?.comment}
          </label>
          <br />
          <label>
            <b>Status:</b> {batch?.status}
          </label>
          <br />
          <h3
            style={{
              borderBottom: "1px solid rgb(204, 204, 204)",
              fontWeight: 400,
              display: "flex",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <span style={{ marginRight: "10px" }}>Withdrawal Requests: </span>
          </h3>

          <BatchWithdrawalRequestsContainer
            name={"settlement.withdrawal.batch.withdrawals"}
          />
        </section>
      </BOGraphQLLoader>
    );
  }
}

const withBatchSummaryGqlData = graphql<GqlQueryResult, Props>(
  gql`
    query WalletWithdrawalsBatchSummary($batchId: ID!) {
      withdrawal_batches(id: $batchId) {
        id
        status
        archive_url
        comment
      }
    }
  `,
  {
    options(props) {
      return {
        fetchPolicy: "network-only",
        variables: {
          batchId: props.match.params.id,
        },
      };
    },
  }
);
const withSubmitWithdrawalBatchMutation = graphql<
  GqlSubmitMutationResult,
  Props
>(
  gql`
    mutation SubmitWithdrawalRequestBatch($batchId: ID!) {
      submit_withdrawal_batch(id: $batchId) {
        id
      }
    }
  `,
  { name: "submitWithdrawalBatchMutation" }
);

export default withDialog(
  compose(
    withBatchSummaryGqlData,
    withSubmitWithdrawalBatchMutation
  )(WithdrawalsBatchSummary)
);
